module.exports = __webpack_public_path__ + "static/media/custom-domain.4fc52bf6.png";